import { useMutation } from "@tanstack/react-query";
import stageService from "../api/stageService";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const useCreateStage = () => {
  const { createStage } = stageService();
  const queryClient = useQueryClient();
  const { boardId } = useParams();

  return useMutation({
    mutationKey: ["create-stage"],
    mutationFn: async ({ stage }) => {
      const response = await createStage(stage);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-stages", boardId],
      });
    },
  });
};

export const useUpdateStage = () => {
  const { updateStage } = stageService();
  const queryClient = useQueryClient();
  const { boardId } = useParams();

  return useMutation({
    mutationKey: ["update-stage"],
    mutationFn: async ({ stage }) => {
      const response = await updateStage(stage);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-stages", boardId],
      });
    },
  });
};

export const useUpdateStageOrder = () => {
  const { updateStageOrder } = stageService();
  const queryClient = useQueryClient();
  const { boardId } = useParams();

  return useMutation({
    mutationKey: ["update-stage-order"],
    mutationFn: async ({ stages }) => {
      const response = await updateStageOrder(stages);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-stages", boardId],
      });
    },
  });
};

export const useDeleteStage = () => {
  const { deleteStage } = stageService();
  const queryClient = useQueryClient();
  const { boardId } = useParams();

  return useMutation({
    mutationKey: ["delete-stage"],
    mutationFn: async ({ stage }) => {
      const response = await deleteStage(stage);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-stages", boardId],
      });
    },
  });
};
